// modules/navigation/index.ts — Platik-IA
import { bus }       from '../../core/event-bus';
import type { NavigationAPI } from './contracts';
import type { TabId }         from './events';

const VALID_TABS: TabId[] = ['registro', 'historial', 'analisis', 'categorias', 'config'];
const isTab = (v: string | null): v is TabId => !!v && (VALID_TABS as string[]).includes(v);

let _current: TabId = 'registro';

export async function initNavigation(): Promise<NavigationAPI> {
  // Leer tab inicial de la URL (validado: un ?tab inválido cae a registro).
  const tabParam = new URLSearchParams(location.search).get('tab');
  if (isTab(tabParam)) _current = tabParam;

  // Normalizar la URL al tab efectivo (sincroniza un ?tab inválido o ausente).
  const initUrl = new URL(location.href);
  if (initUrl.searchParams.get('tab') !== _current) {
    initUrl.searchParams.set('tab', _current);
    history.replaceState({ tab: _current }, '', initUrl.toString());
  }

  // Back button en PWA
  const onPopState = () => {
    const t = new URLSearchParams(location.search).get('tab');
    _current = isTab(t) ? t : 'registro';
    bus.emit('nav:tab-changed', { tab: _current });
  };
  window.addEventListener('popstate', onPopState);

  bus.emit('nav:ready');

  const api: NavigationAPI = {
    goTo(tab: TabId) {
      if (tab === _current) return;
      _current = tab;
      const url = new URL(location.href);
      url.searchParams.set('tab', tab);
      history.pushState({ tab }, '', url.toString());
      bus.emit('nav:tab-changed', { tab });
    },
    current: () => _current,
    dispose() {
      window.removeEventListener('popstate', onPopState);
    },
  };

  return api;
}
